module.exports = __webpack_public_path__ + "static/img/sph_kegy.18f0a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sph_kegy.png
// module id = NI8X
// module chunks = 130